import { defineComponent as _defineComponent } from 'vue'
import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
interface CardToggle {
  type: any;
  icon?: string;
  text: string;
  description?: string;
  disabled?: boolean;
  dataTrack?: string;
}

interface SCardToggleProps {
  items?: CardToggle[];
  mandatory?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SCardToggle',
  props: {
  items: { default: () => [] },
  mandatory: { type: Boolean, default: true },
  value: null
},
  emits: ["input"],
  setup(__props) {




const { value: model } = __MACROS_useVModel(["value", undefined, "input"]);


return { __sfc: true,model, __MACROS_useVModel }
}

})